import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    controlValues: {},
    states: [],
    agencies: [],
  },
  getters: {
    activeControlValues: (state) => (code) => {
      if (state.controlValues[ code ]) {
        return state.controlValues[ code ].filter(value => {
          return value.active === 'Y';
        });
      }
    },
    filingsDueDate: (state) => (year) => {
      return state.controlValues.filingduedate.find(dueDate => {
        return parseInt(dueDate.value) === parseInt(year) && dueDate.active === 'Y';
      });
    },
  },
  mutations: {
    setControlValue (state, controlValue) {
      Vue.set(state.controlValues, controlValue.key, controlValue.value);
    },
    setControlValueCodes (state, controlValueCodes) {
      Vue.set(state, controlValueCodes, controlValueCodes);
    },
  },
  actions: {
    async forgotPassword({ rootState }, emailAddress) {
      try {
        let response = await this.$axios({
          url: rootState.endpoints.forgotPassword,
          method: 'post',
          data: {
            emailAddress,
          },
        });
        return response;
      } catch (error) {
        if (error.response.status === 403) {
          this.$warning(`Your account has not been activated. An activation e-mail was sent to this account. Please activate your account first.`);
        } else if (error.response.status === 404) {
          this.$warning(`We were unable to verify this e-mail address. Please make sure you have the right e-mail address. If problem persists, please contact support.`);
        } else {
          this.$warning(`There was an issue starting the reset process, please refresh your page and try again.`);
        }
        return false;
      }
    },
    async resetUserPassword({ rootState }, data) {
      try {
        let response = await this.$axios({
          url: `${rootState.endpoints.resetPassword}`,
          method: 'put',
          data,
        });
        return response;
      } catch (error) {
        this.$error("There was an issue resetting your password. Please try again. If the problem persists, please contact support.");
        return false;
      }
    },
    updateControlValue({ rootState }, controlValues) {

      let cud = {
        post: [],
        put: [],
        delete: [],
      };

      let items = [ ...controlValues ];

      items.forEach(item => {
        if (item.cud) {
          if (item.cud === 'post') {
            item.id = undefined;
            cud[item.cud].push(item);
          } else if (item.cud === 'put') {
            cud[item.cud].push(item);
          } else if (item.cud === 'delete') {
            cud[item.cud].push(item.id);
          }
        }
      });

      let promises = [];

      for (let type in cud) {
        if (cud[type].length > 0) {
          promises.push(this.$axios({
            method: type,
            url: rootState.endpoints.controlValue,
            data: cud[type],
          }).catch(error => {
            console.warn(error);
          }));
        }
      }

      return new Promise((resolve, reject) => {
        Promise.all(promises).then(() => {
          resolve();
        }).catch(error => {
          reject(console.warn(error));
        });
      });

    },
    getControlValue({ commit, dispatch, rootState }, code) {
      return new Promise((resolve, reject) => {
        this.$axios.get(`${rootState.endpoints.controlValue}`, {
          params: {
            code: code,
          },
        }).then(response => {
          dispatch('sortControlValues', response.data).then(sortedValues => {
            commit('setControlValue', {
              key: code,
              value: sortedValues,
            });
            resolve();
          }).catch(error => {
            console.warn(error);
            reject();
          });
        });
      });
    },
    // eslint-disable-next-line no-unused-vars
    sortControlValues ({ commit }, data) {
      return data.sort((a, b) => {
        return parseInt(a.sequenceNo) - parseInt(b.sequenceNo);
      });
    },
  },
};
